import { buildReplaceReferralUrl } from '@/services/referral/replace-referral-url'
import VeeValidate from 'vee-validate'
import ja from 'vee-validate/dist/locale/ja'
import Vue from 'vue'
import VueHead from 'vue-head'
import Notifications from 'vue-notification'
import VueRouter from 'vue-router'

import App from './components/App.vue'

import Banner from '@/components/atoms/Banner.vue'
import Button from '@/components/atoms/Button.vue'
import Checkbox from '@/components/atoms/Checkbox.vue'
import Input from '@/components/atoms/Input.vue'
import Spinner from '@/components/atoms/Spinner.vue'
import '@/components/global'
import { HlAppMode } from '@/models/hl-app/hl-app-mode'
import { initHlAppSpa } from '@spa/hl-app/init'
import DropdownSelect from './components/atoms/DropdownSelect.vue'
import Link from './components/atoms/Link.vue'
import Radio from './components/atoms/Radio.vue'
import SectionBar from './components/atoms/SectionBar.vue'
import Textarea from './components/atoms/Textarea.vue'
import DefaultTemplate from './components/templates/Default.vue'

import router from './router'
import store from './store'

import { log } from './log'

import '@/validation/email-compatible-with-old-system'

async function initSpa() {

  Vue.use(VueHead)
  Vue.use(VueRouter)

  // TODO: Remove this line, because this is temporary debugging code
  log.debug({ FRONT_ENV: process.env.FRONT_ENV })

  Vue.config.productionTip = false

  Vue.component('spa-default-template', DefaultTemplate)
  Vue.component('spa-input', Input)
  Vue.component('spa-link', Link)
  Vue.component('spa-banner', Banner)
  Vue.component('spa-button', Button)
  Vue.component('spa-section-bar', SectionBar)
  Vue.component('spa-spinner', Spinner)
  Vue.component('spa-textarea', Textarea)
  Vue.component('spa-radio', Radio)
  Vue.component('spa-checkbox', Checkbox)
  Vue.component('spa-dropdown-select', DropdownSelect)

  VeeValidate.Validator.localize('ja', ja)
  // @ts-ignore
  Vue.use(VeeValidate)

  Vue.use(Notifications)

  /**
   * Vueレンダリングの前に、ユーザー情報を取得しておく。
   * 直接的には、ログイン・ユーザ登録画面へアクセスがあったときすでに本会員ならマイページに飛ばす機能があるところ、
   * SPA系ページでオートログインが完了する前にマイページに飛ばすかどうかの判定を行っていたという不具合に対応して、
   * 事前にオートログインをcallWithAuthを通じて実行するために導入された。
   * しかしSPA全般でユーザ情報が必要なはずであるから、ユーザ情報そのものをも併せて取得している。
   *
   * なお、何かのAPI呼び出しのついでにcallWithAuth経由でオートログインが保証されることに比べれば、
   * このSPA初期化処理時に確実にオートログインが保証されることで、オートログインの不安定性は改善されているが、
   * それでもこの初期化処理とそれ以降のSPA処理の間に、暗黙的な依存関係が生じてしまっていて、うっかりここでのオートログイン処理を削除してしまうといった危険性は考えられる。
   * 将来的には、ユーザ情報を利用したいコンポーネント等には外からコンテキストを渡すといった、明示的な型定義を通じた安定性の向上を検討する。
   * @see https://github.com/my-color/growthpalette-front/pull/7681
   * @see https://github.com/my-color/growthpalette-front/pull/7682#discussion_r1381863865
   *
   * なお将来的には、ajax, spaフォルダの統合も見据えつつ、ユーザの認証情報を事前に要求するような仕組みを検討する。
   * ajaxが問題になるMPAの方では、商品詳細やブランドページなどで、事実上オートログインが発火しているにすぎず、明示的にオートログインを特定タイミングで発火させる仕組みにはなっていない。
   */
  await store.dispatch('user/get', { force: true })

  // tslint:disable-next-line:no-unused-expression
  new Vue({
    // This css selector SHOULD be specified in MPA template
    el: '#spa-root',
    router,
    store,
    template: '<App/>',
    components: { App },
  })

  const replaceReferralUrl = await buildReplaceReferralUrl()
  replaceReferralUrl.resolveNode(document.body)
}

/**
 * @see https://my-color.esa.io/posts/1362
 */
if (HlAppMode.isPageForHlApp) {
  /**
   * ホテラバアプリUAでなくても /hlapp/direct/* にアクセスできなければならない
   * /hlapp/direct/purchase-execution など
   */
  initHlAppSpa()
} else if (HlAppMode.isViewedInHlAppWebView) {
  /**
   * ホテラバアプリUAなのに/s/*にアクセスしようとした場合、
   * 現在のパスの /s/* を /hlapp/direct/* に変換する。
   *
   * ただし、以下の点に注意
   * - /s/* と /hlapp/direct/* で「同じページ」が同じパスになっていることを前提としている
   * - /s/* にあって /hlapp/direct/* にないページはホテラバアプリ用SPAがnot found表示を行う
   */
  const newPath = location.pathname.replace(/^\/s\//, '/hlapp/direct/')
  const newUrl = newPath + location.search + location.hash
  location.href = newUrl
} else {
  initSpa()
}
